'use strict';

module.exports = require('./RelyingParty');